import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InfoMode, OP_STATUS, propsEmpty } from "../../util/varibles/constants";
import { IOperation } from "../../util/varibles/interface";
import { initialState } from "./constants";

const opDetailSlice = createSlice({
    name: 'opDetail',
    initialState,
    reducers: {
        getOpRequest: (state, action) => {
            const { tab, id } = action.payload;
            state.keyTab = tab;
            state.infoMode = InfoMode.PLAN;
            state.loadingOp = true;
            state.data = { ...propsEmpty, operation: { id } }
        },
        getOpSuccess: (state, action) => {
            state.loadingOp = false;
            state.data = action.payload;
            state.infoMode = action.payload.operation?.status === OP_STATUS.FINISHED
                ? InfoMode.ACTUAL
                : InfoMode.PLAN;
        },
        getOpFailure: (state) => {
            state.loadingOp = false;
        },
        updatePositionVessel: (state, action) => {
            const { data } = state;
            const { vessel } = data;
            if (vessel) {
                const { gps } = vessel;
                const { name, value, time } = action.payload.data;
                if (!gps || gps[name] === undefined) return state

                const { time: oldTime } = gps || {};
                const [gpsTime] = time.split('.');
                const updateTime = gpsTime[gpsTime.length - 1] === 'Z'
                    ? new Date(gpsTime.replace(' ', 'T')).getTime()
                    : new Date(gpsTime.replace(' ', 'T') + 'Z').getTime();
                const newTime = updateTime > oldTime ? updateTime : oldTime
                state.data = { ...data, vessel: { ...vessel, gps: { ...gps, [name]: value, time: newTime } } }
            }
        },
        updateOp: (state, action: PayloadAction<IOperation[]>) => {
            const { operation = {}, activity_log = [], checklists_v2 } = action.payload[0] || {};
            state.data = {
                ...state.data,
                operation: { ...state.data.operation, ...operation },
                activity_log,
                checklists_v2
            }
        },
        getActualRoute: (state, _: PayloadAction<{ id: string, tenant_id: string }>) => {
            state.loadingRoute = true;
        },
        setInfoMode: (state, action: PayloadAction<InfoMode>) => {
            state.infoMode = action.payload;
        },
        updateState: (state, action: PayloadAction<Partial<typeof state>>) => {
            Object.keys(action.payload).forEach(key => {
                (state as any)[key] = (action.payload as any)[key];
            })
        }
    },
})

export const opDetailActions = opDetailSlice.actions

const opDetailReducer = opDetailSlice.reducer;

export default opDetailReducer;
